import { ThemeProvider } from '@mui/material/styles';
import { ErrorBoundary } from 'Components/ErrorBoundary';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import GlobalStateProvider from 'Providers/GlobalStateProvider';
import { SocketProvider } from 'Providers/SocketProvider';
import { SocketIntegrationProvider } from 'Providers/SocketIntegrationProvider';
import TranslationProvider from 'Providers/TranslationProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from 'Router/Routes';
import { muiTheme } from './theme/muiTheme';
import classes from './App.module.scss';
import './theme/variables.scss';
import { LiftStatusStorage } from './Utils/Storage';
import TanstackQueryProvider from 'Providers/TanstackQueryProvider';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

let userToken = LiftStatusStorage.userToken;

if (urlParams.has('access_token')) {
  const accessToken = urlParams.get('access_token');
  if (accessToken) {
    userToken = accessToken;
    LiftStatusStorage.userToken = userToken;
  }

  if (urlParams.has('start_date') || urlParams.has('end_date')) {
    LiftStatusStorage.period = { unit: 'custom', period: 0 };

    if (urlParams.has('start_date')) {
      const startDate = urlParams.get('start_date');
      if (startDate) {
        LiftStatusStorage.startDate = startDate;
      }
    }
    if (urlParams.has('end_date')) {
      const endDate = urlParams.get('end_date');
      if (endDate) {
        LiftStatusStorage.endDate = endDate;
      }
    }
  }

  if (urlParams.has('organisation_id')) {
    const organisationIdParam = urlParams.get('organisation_id');
    if (organisationIdParam) {
      LiftStatusStorage.organisationId = parseInt(organisationIdParam, 10);
    }
  }

  document.location.href =
    document.location.origin + document.location.pathname;
}

function App() {
  return (
    <NuqsAdapter>
      <ErrorBoundary level="critical">
        <TanstackQueryProvider>
          <SocketProvider>
            <SocketIntegrationProvider>
              <div className={classes.App}>
                <TranslationProvider>
                  <GlobalStateProvider userToken={userToken}>
                    <ThemeProvider theme={muiTheme}>
                      <ErrorBoundary level="page">
                        <Routes />
                      </ErrorBoundary>
                    </ThemeProvider>
                  </GlobalStateProvider>
                </TranslationProvider>
                <ToastContainer
                  position="bottom-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="dark"
                />
              </div>
            </SocketIntegrationProvider>
          </SocketProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </TanstackQueryProvider>
      </ErrorBoundary>
    </NuqsAdapter>
  );
}

export default App;
